<template>
  <h3>{{ convertTitle }}</h3>
</template>

<script>
export default {
  name: 'ShootingTitleType',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    convertTitle() {
      const type = this.type

      switch (type) {
        case 'ORIGINAL':
          return this.$t('shooting.types.original')
        case 'ORIGINAL_LPC':
          return this.$t('shooting.types.originalLpc')
        case 'STAMPED_LPC':
          return this.$t('shooting.types.stampedLpc')
        case 'ORIGINAL_CROPPED_LPC':
          return this.$t('shooting.types.originalCroppedLpc')
        case 'STAMPED_CROPPED_LPC':
          return this.$t('shooting.types.stampedCroppedLpc')
        case 'ORIGINAL_CROPPED':
          return this.$t('shooting.types.originalCropped')
        case 'STAMPED_CROPPED':
          return this.$t('shooting.types.stampedCropped')
        case 'BACKGROUND_CROPPED':
          return this.$t('shooting.types.backgroundCropped')
        case 'STAMPED':
          return this.$t('shooting.types.stamped')
        default:
          return ''
      }
    }
  }
}
</script>
